require.config({
    baseUrl: 'js', // Relative to index

    paths: {
        // node modules
        lodash: '../node_modules/lodash/lodash',
        moment: '../node_modules/moment/min/moment.min',
        momentTimezone: '../node_modules/moment-timezone/builds/moment-timezone-with-data-2010-2020.min',
        Graph: '../node_modules/@tvg/graph/dist/tvg-graph.mod.umd',
        DepositGTM: '../node_modules/@tvg/deposit-gtm/build/bundle',
        Deposit: '../node_modules/@tvg/deposit/modules',

        //Vendors
        angular: 'vendors/angular/angular.min',
        angularRoute: 'vendors/angular-route/angular-route.min',
        angularSanitize: 'vendors/angular-sanitize/angular-sanitize.min',
        angularAnimate: 'vendors/angular-animate/angular-animate.min',
        ngMd5: 'vendors/angular-md5/angular-md5.min',
        uibootstrap: 'vendors/angular-bootstrap/ui-bootstrap.min',
        uibootstraptpls: 'vendors/angular-bootstrap/ui-bootstrap-tpls.min',
        angularCookies: 'vendors/angular-cookies/angular-cookies.min',
        angularCookie: 'vendors/angular-cookie/angular-cookie.min',
        angularUTF8Base64: 'vendors/angular-utf8-base64/angular-utf8-base64.min',
        muton: 'vendors/muton/muton.window',
        Configuration: 'vendors/tvg-configuration/configurationMod.min',
        Content: 'vendors/tvg-content/contentMod.min',
        matchMedia: 'vendors/matchMedia/matchMedia',
        ngDialog: 'vendors/ng-dialog/js/ngDialog',
        angularFilter: 'vendors/angular-filter/dist/angular-filter',
        TVGCommon: 'vendors/tvg-common/dist/TVGCommon.umd.min',
        uiMask: 'vendors/angular-ui-mask/dist/mask.min',

        //App core module
        app: 'app',
        AppCore: 'modules/AppCore/appCoreMod',
        AppRootFac: 'modules/AppCore/providers/appRootFac',
        AppRequestInterceptor: 'modules/AppCore/providers/appRequestInterceptor',

        //Poller module
        Poller: 'modules/Poller/pollerMod',

        //  BetTicket Module
        BetService: 'modules/BetService/betServiceBase',
        BetsSvc: 'modules/BetService/providers/betsSvcV2',
        StepSelectionsStringFilter: 'modules/BetService/filters/stepSelectionsStringFilter',

        //  BetSlip Window Module
        BetSlipWindow: 'modules/BetSlipWindow/betSlipWindowMod',
        BetSlipWindowCtrl: 'modules/BetSlipWindow/controllers/betSlipWindowCtrl',
        BetSlipWindowDir: 'modules/BetSlipWindow/directives/betslip-window-directive',
        BetSlipAccountInfoDir: 'modules/BetSlipWindow/directives/betslip-account-info-directive',
        BetSlipAlertBannerDir: 'modules/BetSlipWindow/directives/betslip-alert-banner-directive',
        BetSlipAccountInfoCtrl: 'modules/BetSlipWindow/controllers/betSlipAccountInfoCtrl',
        BetSlipWindowAlertsFac: 'modules/BetSlipWindow/providers/betSlipWindowAlertsFac',
        TrackSelectorWindowCtrl: 'modules/BetSlipWindow/controllers/trackSelectorWindowCtrl',
        TrackSelectorWindowDir: 'modules/BetSlipWindow/directives/track-selector-window-directive',
        RunnerSaddleModel: 'modules/BetSlipWindow/models/runnerSaddleModel',

        //Features Module
        Features: 'modules/Features/featuresMod',
        FeaturesFac: 'modules/Features/providers/factories/featuresFac',
        FeaturesConfigController: 'modules/Features/controllers/featuresConfigController',

        // GTM
        GTMMod                                           : 'modules/GTM/gtmMod',
        GTMFac                                           : 'modules/GTM/providers/GTMFac',
        RegistrationPageGTMFac                           : 'modules/GTM/providers/registrationPageGTMFac',
        ScreenNames                                      : 'modules/GTM/constants/screenNames',
        SectionNames                                     : 'modules/GTM/constants/sectionNames',

        //RaceInfo Module
        RaceInfo: 'modules/RaceInfo/raceInfoMod',
        RaceUrlFac: 'modules/RaceInfo/providers/raceUrlFac',
        RaceParamsEntity: 'modules/RaceInfo/entities/raceParamsEntity',
        RaceParamsEntityBuilder: 'modules/RaceInfo/builders/raceParamsEntityBuilder',
        RaceInfoFac: 'modules/RaceInfo/providers/raceInfoFac',
        RaceMTP: 'modules/RaceInfo/filters/raceMTP',
        RaceLinkFilter: 'modules/RaceInfo/filters/raceLinkFilter',
        RaceMtpStatusFac: 'modules/RaceInfo/providers/raceMtpStatusFac',

        //Races Module
        Races: 'modules/Races/racesMod',
        RaceMTPFilter: 'modules/Races/filters/raceMTPFilter',
        MtpDisplayModel: 'modules/Races/controllers/models/mtpDisplay',
        RaceStatusUtils: 'modules/Utilities/tools/raceStatusUtils',
        RaceStatusLabelDir: 'modules/Races/directives/race-status-label-directive',
        RaceMtpLabelDir: 'modules/Races/components/raceMtpLabel/directives/raceMtpLabelDir',
        RaceMtpLabelMod: 'modules/Races/components/raceMtpLabel/raceMtpLabelMod',

        //Track Selector Module
        TrackSelectorCtrl: 'modules/Tracks/components/trackSelector/controllers/trackSelectorCtrl',
        TrackSelectorDir: 'modules/Tracks/components/trackSelector/directives/track-selector-directive',
        TrackSelectorItem: 'modules/Tracks/components/trackSelector/models/trackSelectorItem',
        TrackSelectorItemBuilder: 'modules/Tracks/components/trackSelector/models/builders/trackSelectorItemBuilder',
        TrackSelectorItemFactory: 'modules/Tracks/components/trackSelector/factories/trackSelectorItemFactory',
        TrackSelectorItemCurrentRaceFactory: 'modules/Tracks/components/trackSelector/factories/trackSelectorItemCurrentRaceFactory',
        TrackSelector: 'modules/Tracks/components/trackSelector/trackSelectorMod',

        // Track Module
        Track: 'modules/Track/trackMod',
        TrackSvc: 'modules/Track/providers/trackSvc',

        // Security Module
        Security: 'modules/Security/securityMod',
        SecuritySvc: 'modules/Security/providers/securitySvc',
        UserSessionSvc: 'modules/Security/providers/userSessionSvc',
        GeoComplyLoginSvc: 'modules/Security/providers/geoComplyLoginSvc',
        GeoComplySvc: 'modules/Security/providers/geoComplySvc',
        PollingScheduler: 'modules/Security/providers/pollingScheduler',

        // UserProfile Module
        UserProfile: 'modules/UserProfile/userProfileMod',
        UserProfileSvc: 'modules/UserProfile/providers/services/userProfileSvc',
        UserBalanceSvc: 'modules/UserProfile/providers/services/userBalanceSvc',
        StatesSvc: 'modules/UserProfile/providers/services/statesSvc',
        PasswordValidatorSvc: 'modules/UserProfile/providers/helpers/passwordValidatorSvc',
        UsernameValidatorSvc: 'modules/UserProfile/providers/helpers/usernameValidatorSvc',
        ProfileHelperSvc: 'modules/UserProfile/providers/helpers/profileHelperSvc',
        QuickDepositCtrl: 'modules/UserProfile/controllers/quickDepositCtrl',

        // Layout Module
        Layout: 'modules/Layout/layoutMod',
        LayoutDir: 'modules/Layout/directives/layout-directive',
        SwitchLayoutForDir: 'modules/Layout/directives/switch-layout-for-directive',
        LayoutFac: 'modules/Layout/providers/factories/layoutFac',

        // Utilities Module
        Utilities: 'modules/Utilities/utilitiesMod',
        CookieFac: 'modules/Utilities/providers/factories/cookieFac',
        PreferencesCookieFac: 'modules/Utilities/providers/factories/preferencesCookieFac',
        FavoriteCookieFac: 'modules/Utilities/providers/factories/favoriteCookieFac',
        LocalStorageFac: 'modules/Utilities/providers/factories/localStorageFac',
        LocationUnreloadFac: 'modules/Utilities/providers/factories/locationUnreloadFac',
        DateTimeFormatters: 'modules/Utilities/formatters/dateTimeFormatters',
        StatePersistenceFac: 'modules/Utilities/providers/factories/statePersistenceFac',
        FeaturesHandlerSvc: 'modules/Utilities/providers/service/featuresHandlerSvc',
        UserPropertiesSvc: 'modules/Utilities/providers/service/userPropertiesSvc',
        RaceMtpDisplay: 'modules/Utilities/tools/raceMtpDisplay',
        WagerProfileFac: 'modules/Utilities/providers/factories/wagerProfileFac',
        TvgHostsFac: 'modules/Utilities/providers/factories/tvgHostsFac',
        AmountOptionsFac: 'modules/Utilities/providers/factories/amountOptionsFac',

        PreventDefaultDir: 'modules/Utilities/directives/prevent-default-directive',

        NewWindowGridFac: 'modules/Utilities/providers/factories/newWindowGridFac',
        GetNestedPropertyValueFilter: 'modules/Utilities/filters/getNestedPropertyValueFilter',
        GetRelativeDayBasedOnGivenDateFilter: 'modules/Utilities/filters/getRelativeDayBasedOnGivenDateFilter',

        DateComparators: 'modules/Utilities/formatters/dateComparators',
        RoundAmountFilter: 'modules/Utilities/filters/roundAmountFilter',
        ReverseFilter: 'modules/Utilities/filters/reverseFilter',
        RaceTypeIDFilter: 'modules/Utilities/filters/raceTypeIDFilter',

        tvgTemplates: 'tvg.templates',

        //Favorite Tracks
        FavoriteTracks: 'modules/FavoriteTracks/favoriteTracksMod',
        FavoriteTracksFac: 'modules/FavoriteTracks/providers/favoriteTracksFac',

        //Preferences
        Preferences: 'modules/Preferences/preferencesMod',
        PreferencesFac: 'modules/Preferences/providers/preferencesFac',
        PreferencesEntity: 'modules/Preferences/entities/preferencesEntity',
        PreferencesEntityBuilder: 'modules/Preferences/builders/preferencesEntityBuilder',

        //Features JSON
        defaultFeatures: 'defaultFeatures',

        MathAbsoluteValueFilter : 'modules/Utilities/filters/mathAbsoluteValueFilter',

        // BetSlip Main Module
        BetslipMainMod: 'modules/Main/betslipMainMod',
        CrossWindowMessagingFac: 'modules/Main/providers/crossWindowMessagingFac',

        // GTM factory decorator
        GTMFacDecorator: 'modules/GTM/providers/gtmFacDecorator',
        GTMDesktopMod: 'modules/GTM/gtmDesktopMod',

        //Common
        initData: 'initData'
    },
    shim: {
        angular: { exports: 'angular' },
        lodash: { exports: '_' },
        muton: { exports: 'muton' },
        angularRoute: ['angular'],
        angularAnimate: ['angular'],
        ngMd5: ['angular'],
        angularCookies: ['angular'],
        angularCookie: ['angular'],
        angularUTF8Base64: ['angular'],
        uibootstrap: ['angular'],
        uibootstraptpls: ['uibootstrap'],
        Poller: ['angular'],
        Deposit: ['angular'],
        Configuration: ['angular', 'matchMedia'],
        Content: ['angular'],
        angularSanitize: ['angular'],
        ngDialog: ['angular'],
        angularFilter: ['angular'],
        TVGCommon: ['angular'],
        uiMask: ['angular'],
        app: [
            'initData',
            'defaultFeatures',
            'Poller',
            'angularRoute',
            'uibootstraptpls',
            'angularSanitize',
            'angularAnimate',
            'angularCookies',
            'angularCookie',
            'angularUTF8Base64',
            'lodash',
            'ngMd5',
            'muton',
            'moment',
            'ngDialog',
            'angularFilter',
            'TVGCommon',
            'uiMask',
            'Deposit'
        ]
    },
    priority: ['angular'],
    deps: ['./bootstrap']
});

define("main", function(){});

